import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Hidden from "@material-ui/core/Hidden";

export default function SummonerRow({ summoner, idx, classes }) {
  if (!summoner) {
    return null;
  }
  if (
    summoner.tier === "CHALLENGER" ||
    summoner.tier === "GRANDMASTER" ||
    summoner.tier === "MASTER" ||
    summoner.tier === "UNRANKED"
  ) {
    summoner.rank = "";
  }
  summoner.tier = summoner.tier.toLowerCase();
  summoner.tier =
    summoner.tier.charAt(0).toUpperCase() + summoner.tier.slice(1);

  if (summoner.tier !== "Unranked") {
    summoner.leaguePointsString = `(${summoner.leaguePoints} LP)`;
  } else {
    summoner.leaguePointsString = "";
  }

  if (summoner.sortingData.winRatio === "NaN") {
    summoner.sortingData.winRatio = "--";
  }

  var liveLogo;
  if (summoner.live) {
    liveLogo = (
      <div
        style={{
          fontSize: "14px",
          display: "inline-block",
          backgroundColor: "red",
          fontWeight: "bold",
          padding: "0px 5px 0px 5px",
          border: "3px solid red",
          borderRadius: "5px",
          color: "white"
        }}
      >
        {" "}
        LIVE{" "}
      </div>
    );
  } else {
    liveLogo = "";
  }

  return (
    <TableRow>
      <TableCell
        classes={{ body: classes.cell }}
        style={{ width: 40, paddingRight: 10 }}
      >{`#${idx + 1}`}</TableCell>
      <TableCell classes={{ body: classes.cell }}>
        <a href={summoner.twitchUrl} target="blank">
          {summoner.title}
        </a>
        {`  `}
        {liveLogo}
      </TableCell>
      <Hidden mdDown>
        <TableCell classes={{ body: classes.cell }}>
          <a href={summoner.opgg} target="blank">
            {summoner.summonerName}
          </a>
        </TableCell>
      </Hidden>
      <TableCell classes={{ body: classes.cell }}>
        {summoner.tier &&
          `${summoner.tier} ${summoner.rank} ${summoner.leaguePointsString}`}
      </TableCell>
      <Hidden smDown>
        <TableCell classes={{ body: classes.cell }}>
          {summoner.tier &&
            `${summoner.wins}W - ${summoner.losses}L` +
              " (" +
              (summoner.sortingData && summoner.sortingData.winRatio) +
              "%)"}
        </TableCell>
      </Hidden>
    </TableRow>
  );
}
